// source: https://github.com/apexcharts/apexcharts.js/blob/main/src/modules/Data.js

import ApexSeries from 'services/apex-chart-services/utils/apex-series';

export default class ApexData {
  constructor(ctx) {
    this.ctx = ctx;
    this.w = ctx.w;
  }

  // given format is [{x, y}, {x, y}]
  isFormatXY() {
    const series = this.w.config.series.slice();

    const sr = new ApexSeries(this.ctx);
    this.activeSeriesIndex = sr.getActiveConfigSeriesIndex();

    if (
      typeof series[this.activeSeriesIndex].data !== 'undefined' &&
      series[this.activeSeriesIndex].data.length > 0 &&
      series[this.activeSeriesIndex].data[0] !== null &&
      typeof series[this.activeSeriesIndex].data[0].x !== 'undefined' &&
      series[this.activeSeriesIndex].data[0] !== null
    ) {
      return true;
    }
  }

  // given format is [[x, y], [x, y]]
  isFormat2DArray() {
    const series = this.w.config.series.slice();

    const sr = new ApexSeries(this.ctx);
    this.activeSeriesIndex = sr.getActiveConfigSeriesIndex();

    if (
      typeof series[this.activeSeriesIndex].data !== 'undefined' &&
      series[this.activeSeriesIndex].data.length > 0 &&
      typeof series[this.activeSeriesIndex].data[0] !== 'undefined' &&
      series[this.activeSeriesIndex].data[0] !== null &&
      series[this.activeSeriesIndex].data[0].constructor === Array
    ) {
      return true;
    }
  }
}
